import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgWizardService } from "ng-wizard";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
// import { AlertService } from "src/app/services/alert/AlertService";



@Component({
  selector: 'app-image-task-list',
  templateUrl: './image-task-list.component.html',
  styleUrls: ['./image-task-list.component.scss']
})
export class ImageTaskListComponent implements OnInit {
  enagagementDeatail: any = [];
  formGroup;
  getPaginationCount;
  addOrEditCampaign: any;
  deletePopupUiData;
  submitted: boolean = false;
  page: any = 1;
  protfolioId: any = "";

  search = "";
  startDate: any = "";
  endDate: any = "";
  portfolio: any = "";
  engagementTypes: any = "";
  selectedEngagemet: any = "";
  startNepaliDate: any;
  endNepaliDate: any;
  date = new Date()
  addOrEditEngagement: string = 'add'
  constructor(
    public modalService: NgbModal,
    public fb: FormBuilder,
    public ngWizardService: NgWizardService,
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public router: Router,
    // public alertService: AlertService,

  ) { }

  ngOnInit() {
    this.getEngagement();
  }

  get f() {
    return this.formGroup.controls;
  }

  addimageTask(addOrEdit,data?) {
    let engagementId
    this.addOrEditEngagement = addOrEdit
    let engagementStepFlags = {
      createEngagementFlag : addOrEdit == 'add' ? true : true,
      whitelistFlag : addOrEdit == 'add' ? false : true
    }
    let engagementDetail = {
      task_id : addOrEdit == 'edit' ? data.task_id : "",
      sub_tasks_id: addOrEdit == 'edit' ?  data.sub_task : "",
      has_subtask: addOrEdit == 'edit' ?  data.has_subtask : "",
      engagement_type_id : addOrEdit == 'edit' ? data.engagement_type_id : "",
      portfolio_id : addOrEdit == 'edit' ? data.portfolio_id : "",
      is_edit : addOrEdit == 'edit' ? true : false ,
      start_date : addOrEdit == 'edit' ? data.start_date : "",
      end_date : addOrEdit == 'edit' ? data.end_date : "",
      pre_expiry_date : addOrEdit == 'edit' ? data.pre_expiry_date : "",
      points_calculation_flag: addOrEdit == 'edit' ? data.points_calculation_flag : '',
      whitelist_type: addOrEdit == 'edit'? data.whitelist_type:'',
      zone_type : addOrEdit == 'edit'? data.zone_type:'',
      role_type : addOrEdit == 'edit'? data.role_type:'',
      zone_id : addOrEdit == "edit" ? data.zone_id:'',
    }
    addOrEdit === 'edit' ? engagementId = data.task_id : engagementId =  0

    localStorage.setItem("engagementStepFlags", JSON.stringify(engagementStepFlags))
    localStorage.setItem("engagementDetail", JSON.stringify(engagementDetail))
    this.router.navigate(["/hubAdmin/image-task-setup/" + engagementId]);
  }

  getEngagement() {
    console.log(this.startDate, this.endDate)
    this.apiService.getHeaders(this.apiConfig.engagementList + `?engagement_page=1&page=${this.page}&start_date=${this.startDate}&end_date=${this.endDate}&search=${this.search}&portfolio_id=${this.portfolio}&engagement_type_id=${this.selectedEngagemet}`)
      .subscribe((res: any) => {
        this.enagagementDeatail = res.body.data.data;
        console.log(this.enagagementDeatail)
        this.getPaginationCount = res.body.data.pagination.totalCount
      })
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getEngagement();
  }
  status_change(data){
console.log(data);
return
  }


reset(){
  this.startDate = ''
  this.endDate = ''
  this.search = ''
  this.getEngagement()
}
}
